import React, { Component } from 'react';
import "./styles/Card.css";

export class Card extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selected: false
        }
    }
    onClick = () => {
        this.setState({ selected: true })
        if (this.props.onClick) {
            this.props.onClick(this.props.id)
        }
    }
    render() {
        return (
            <div className={`panel panel-card ${this.props.className}`}>
                <div className="panel-header card-header">
                    <label>{this.props.header}</label>
                </div>
                <div className="panel-body card-body">
                    <label className="card-text">{this.props.label}</label>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/common/Card.js